/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.ts to modify the generation of this file.


import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-nextjs';


import * as CableGuide from 'src/components/CableGuide';
import * as CookiePolicy from 'src/components/CookiePolicy';
import * as PaymentMethodsBanner from 'src/components/PaymentMethodsBanner';
import * as TextBanner from 'src/components/TextBanner';
import * as TextSpot from 'src/components/TextSpot';
import * as TopSection from 'src/components/TopSection';
import * as TopWarningMessage from 'src/components/TopWarningMessage';
import * as VideoBanner from 'src/components/VideoBanner';
import * as BusinessClubBanner from 'src/components/BusinessClubBanner/BusinessClubBanner';
import * as CaseStudiesFilter from 'src/components/CaseStudies/CaseStudiesFilter';
import * as CaseStudiesSpot from 'src/components/CaseStudies/CaseStudiesSpot';
import * as CaseStudyTile from 'src/components/CaseStudies/CaseStudyTile';
import * as CaseStudyVideoComponent from 'src/components/CaseStudies/CaseStudyVideoComponent';
import * as caseStudiesTypes from 'src/components/CaseStudies/caseStudiesTypes';
import * as CaseStudyNavigation from 'src/components/CaseStudyNavigation/CaseStudyNavigation';
import * as CategoryPromoSlider from 'src/components/CategoryPromo/CategoryPromoSlider';
import * as CategoryPromoSlides from 'src/components/CategoryPromo/CategoryPromoSlides';
import * as CategoryPromoSpot from 'src/components/CategoryPromo/CategoryPromoSpot';
import * as CategoryPromoSpotSliderButton from 'src/components/CategoryPromo/CategoryPromoSpotSliderButton';
import * as categoryPromoSpotTypes from 'src/components/CategoryPromo/categoryPromoSpotTypes';
import * as DistributorLocator from 'src/components/DistributorLocator/DistributorLocator';
import * as DistributorLocatorLoader from 'src/components/DistributorLocator/DistributorLocatorLoader';
import * as DownloadableResourceGroup from 'src/components/DownloadableResourceList/DownloadableResourceGroup';
import * as DownloadableResourceItem from 'src/components/DownloadableResourceList/DownloadableResourceItem';
import * as DownloadableResourceList from 'src/components/DownloadableResourceList/DownloadableResourceList';
import * as downloadableResourceListTypes from 'src/components/DownloadableResourceList/downloadableResourceListTypes';
import * as WidgetEmbed from 'src/components/FireworkWidget/WidgetEmbed';
import * as SimpleFormWrapper from 'src/components/Forms/SimpleFormWrapper';
import * as HearingTest from 'src/components/HearingTest/HearingTest';
import * as IconTiles from 'src/components/IconTiles/IconTiles';
import * as Breadcrumb from 'src/components/Layout/Footer/Breadcrumb/Breadcrumb';
import * as Footer from 'src/components/Layout/Footer/Footer/Footer';
import * as CondensedMenu from 'src/components/Layout/Header/CondensedMenu/CondensedMenu';
import * as LanguageSelector from 'src/components/Layout/Header/LanguageSelector/LanguageSelector';
import * as Header from 'src/components/Layout/Header/MegaMenu/Header';
import * as Search from 'src/components/Layout/Search/Search';
import * as LinkBlock from 'src/components/LinkBlock/LinkBlock';
import * as LoginCard from 'src/components/LoginSpot/LoginCard';
import * as LoginSpot from 'src/components/LoginSpot/LoginSpot';
import * as PartnerLocator from 'src/components/PartnerLocator/PartnerLocator';
import * as SustainabilitySpot from 'src/components/Product/SustainabilitySpot';
import * as ANCTypes from 'src/components/Product/ANCTypes/ANCTypes';
import * as AccessorySpot from 'src/components/Product/AccessorySpot/AccessorySpot';
import * as SliderCardWithPrice from 'src/components/Product/AccessorySpot/SliderCardWithPrice';
import * as SliderWithPrice from 'src/components/Product/AccessorySpot/SliderWithPrice';
import * as AlternativeSuggestionsSpot from 'src/components/Product/AlternativeSuggestionsSpot/AlternativeSuggestionsSpot';
import * as BentoGrid from 'src/components/Product/BentoGrid/BentoGrid';
import * as BrandStickersSpot from 'src/components/Product/BrandStickers/BrandStickersSpot';
import * as AwardsSpot from 'src/components/Product/Buy/AwardsSpot/AwardsSpot';
import * as BoxContent from 'src/components/Product/Buy/BoxContent/BoxContent';
import * as EcomBenefits from 'src/components/Product/Buy/EcomBenefits/EcomBenefits';
import * as FAQSpot from 'src/components/Product/Buy/FAQ/FAQSpot';
import * as GlobalDealsRibbon from 'src/components/Product/Buy/GlobalDealsRibbon/GlobalDealsRibbon';
import * as HeroCustomizer from 'src/components/Product/Buy/HeroCustomizer/HeroCustomizer';
import * as Hotspots from 'src/components/Product/Buy/Hotspots/Hotspots';
import * as KSPSpot from 'src/components/Product/Buy/KSPSpot/KSPSpot';
import * as PillSlider from 'src/components/Product/Buy/PillSlider/PillSlider';
import * as SupportSpot from 'src/components/Product/Buy/Support/SupportSpot';
import * as TopBanner from 'src/components/Product/Buy/TopBanner/TopBanner';
import * as CompareTableColumn from 'src/components/Product/CompareTablesSpot/CompareTableColumn';
import * as CompareTablesSpot from 'src/components/Product/CompareTablesSpot/CompareTablesSpot';
import * as compareTableSpotTypes from 'src/components/Product/CompareTablesSpot/compareTableSpotTypes';
import * as ContentSliderSpot from 'src/components/Product/ContentSliderSpot/ContentSliderSpot';
import * as CustomerStorySpot from 'src/components/Product/CustomerStorySpot/CustomerStorySpot';
import * as DualColumnPromoItem from 'src/components/Product/DualColumnPromo/DualColumnPromoItem';
import * as DualColumnPromoSpot from 'src/components/Product/DualColumnPromo/DualColumnPromoSpot';
import * as dualColumnPromoTypes from 'src/components/Product/DualColumnPromo/dualColumnPromoTypes';
import * as EnterpriseBatterySpot from 'src/components/Product/EnterpriseBatterySpot/EnterpriseBatterySpot';
import * as EnterpriseGenericPromoSpot from 'src/components/Product/EnterpriseGenericPromoSpot/EnterpriseGenericPromoSpot';
import * as EnterpriseImageSpot from 'src/components/Product/EnterpriseImageSpot/EnterpriseImageSpot';
import * as GallerySliderSpot from 'src/components/Product/GallerySliderSpot/GallerySliderSpot';
import * as GenericBentoGrid from 'src/components/Product/GenericBentoGrid/GenericBentoGrid';
import * as IconTableSpot from 'src/components/Product/IconTableSpot/IconTableSpot';
import * as IntroSection from 'src/components/Product/IntroSection/IntroSection';
import * as introSectionTypes from 'src/components/Product/IntroSection/introSectionTypes';
import * as GenericKSPSpot from 'src/components/Product/KSP/GenericKSPSpot';
import * as GenericKSPCardsSpot from 'src/components/Product/KSP/Card/GenericKSPCardsSpot';
import * as KSPHiddenInfoSpot from 'src/components/Product/KSP/HiddenInfo/KSPHiddenInfoSpot';
import * as PlaceholderContainerContext from 'src/components/Product/KSP/Placeholder/PlaceholderContainerContext';
import * as ScrollingKSPSpot from 'src/components/Product/KSP/Scrolling/ScrollingKSPSpot';
import * as ZoomKSPSpot from 'src/components/Product/KSP/Zoom/ZoomKSPSpot';
import * as LogoSpot from 'src/components/Product/LogoSpot/LogoSpot';
import * as MediaTabs from 'src/components/Product/MediaTabs/MediaTabs';
import * as ProductFilterModuleSpot from 'src/components/Product/ProductFilterModule/ProductFilterModuleSpot';
import * as ProductTopBanner from 'src/components/Product/ProductTopBanner/ProductTopBanner';
import * as RelatedProducts from 'src/components/Product/RelatedProducts/RelatedProducts';
import * as SAPromoSpot from 'src/components/Product/SAPromoSpot/SAPromoSpot';
import * as ServiceCard from 'src/components/Product/ServicesSpot/ServiceCard';
import * as ServicesSpot from 'src/components/Product/ServicesSpot/ServicesSpot';
import * as SingleImageSpot from 'src/components/Product/SingleImageSpot/SingleImageSpot';
import * as Slider from 'src/components/Product/Slider/Slider';
import * as SliderCard from 'src/components/Product/Slider/SliderCard';
import * as SliderSpot from 'src/components/Product/Slider/SliderSpot';
import * as sliderTypes from 'src/components/Product/Slider/sliderTypes';
import * as SoundDemo from 'src/components/Product/SoundDemo/SoundDemo';
import * as soundDemoTypes from 'src/components/Product/SoundDemo/soundDemoTypes';
import * as SoundDemoClipSwitch from 'src/components/Product/SoundDemo/components/SoundDemoClipSwitch';
import * as SoundDemoClipToggleGroup from 'src/components/Product/SoundDemo/components/SoundDemoClipToggleGroup';
import * as SoundDemoEnvironmentSelect from 'src/components/Product/SoundDemo/components/SoundDemoEnvironmentSelect';
import * as SoundDemoPlayer from 'src/components/Product/SoundDemo/components/SoundDemoPlayer';
import * as StatsSpot from 'src/components/Product/StatsSpot/StatsSpot';
import * as statsSpotTypes from 'src/components/Product/StatsSpot/statsSpotTypes';
import * as Disclaimer from 'src/components/Product/StatsSpot/components/Disclaimer';
import * as Stat from 'src/components/Product/StatsSpot/components/Stat';
import * as DesktopTabNavigation from 'src/components/Product/TabNavigation/DesktopTabNavigation';
import * as ImageTabSlider from 'src/components/Product/TabNavigation/ImageTabSlider';
import * as MobileTabNavigation from 'src/components/Product/TabNavigation/MobileTabNavigation';
import * as TabNavigationContentItem from 'src/components/Product/TabNavigation/TabNavigationContentItem';
import * as TabNavigationItem from 'src/components/Product/TabNavigation/TabNavigationItem';
import * as TabNavigationSpot from 'src/components/Product/TabNavigation/TabNavigationSpot';
import * as tabNavigationSpotTypes from 'src/components/Product/TabNavigation/tabNavigationSpotTypes';
import * as TechSpec from 'src/components/Product/TechSpec/TechSpec';
import * as TopBannerSlider from 'src/components/Product/TopBannerSlider/TopBannerSlider';
import * as VideoRoiCalculator from 'src/components/Product/VideoRoiCalculator/VideoRoiCalculator';
import * as VideoSpot from 'src/components/Product/VideoSpot/VideoSpot';
import * as CoveoUserAnalytics from 'src/components/Search/components/CoveoUserAnalytics';
import * as CoveoAnalyticsProvider from 'src/components/Search/providers/CoveoAnalyticsProvider';
import * as coveoAnalyticscontext from 'src/components/Search/providers/coveoAnalytics.context';
import * as useCoveoAnalyticsConfig from 'src/components/Search/providers/useCoveoAnalyticsConfig';
import * as StyleGuide from 'src/components/StyleGuide/StyleGuide';
import * as HeaderCell from 'src/components/Table/HeaderCell';
import * as IconCell from 'src/components/Table/IconCell';
import * as RichTextCell from 'src/components/Table/RichTextCell';
import * as TableCell from 'src/components/Table/TableCell';
import * as TableRow from 'src/components/Table/TableRow';
import * as TableSpot from 'src/components/Table/TableSpot';
import * as tableSpotTypes from 'src/components/Table/tableSpotTypes';

export const components = new Map();

components.set('CableGuide', CableGuide);
components.set('CookiePolicy', CookiePolicy);
components.set('PaymentMethodsBanner', PaymentMethodsBanner);
components.set('TextBanner', TextBanner);
components.set('TextSpot', TextSpot);
components.set('TopSection', TopSection);
components.set('TopWarningMessage', TopWarningMessage);
components.set('VideoBanner', VideoBanner);
components.set('BusinessClubBanner', BusinessClubBanner);
components.set('CaseStudiesFilter', CaseStudiesFilter);
components.set('CaseStudiesSpot', CaseStudiesSpot);
components.set('CaseStudyTile', CaseStudyTile);
components.set('CaseStudyVideoComponent', CaseStudyVideoComponent);
components.set('caseStudiesTypes', caseStudiesTypes);
components.set('CaseStudyNavigation', CaseStudyNavigation);
components.set('CategoryPromoSlider', CategoryPromoSlider);
components.set('CategoryPromoSlides', CategoryPromoSlides);
components.set('CategoryPromoSpot', CategoryPromoSpot);
components.set('CategoryPromoSpotSliderButton', CategoryPromoSpotSliderButton);
components.set('categoryPromoSpotTypes', categoryPromoSpotTypes);
components.set('DistributorLocator', DistributorLocator);
components.set('DistributorLocatorLoader', DistributorLocatorLoader);
components.set('DownloadableResourceGroup', DownloadableResourceGroup);
components.set('DownloadableResourceItem', DownloadableResourceItem);
components.set('DownloadableResourceList', DownloadableResourceList);
components.set('downloadableResourceListTypes', downloadableResourceListTypes);
components.set('WidgetEmbed', WidgetEmbed);
components.set('SimpleFormWrapper', SimpleFormWrapper);
components.set('HearingTest', HearingTest);
components.set('IconTiles', IconTiles);
components.set('Breadcrumb', Breadcrumb);
components.set('Footer', Footer);
components.set('CondensedMenu', CondensedMenu);
components.set('LanguageSelector', LanguageSelector);
components.set('Header', Header);
components.set('Search', Search);
components.set('LinkBlock', LinkBlock);
components.set('LoginCard', LoginCard);
components.set('LoginSpot', LoginSpot);
components.set('PartnerLocator', PartnerLocator);
components.set('SustainabilitySpot', SustainabilitySpot);
components.set('ANCTypes', ANCTypes);
components.set('AccessorySpot', AccessorySpot);
components.set('SliderCardWithPrice', SliderCardWithPrice);
components.set('SliderWithPrice', SliderWithPrice);
components.set('AlternativeSuggestionsSpot', AlternativeSuggestionsSpot);
components.set('BentoGrid', BentoGrid);
components.set('BrandStickersSpot', BrandStickersSpot);
components.set('AwardsSpot', AwardsSpot);
components.set('BoxContent', BoxContent);
components.set('EcomBenefits', EcomBenefits);
components.set('FAQSpot', FAQSpot);
components.set('GlobalDealsRibbon', GlobalDealsRibbon);
components.set('HeroCustomizer', HeroCustomizer);
components.set('Hotspots', Hotspots);
components.set('KSPSpot', KSPSpot);
components.set('PillSlider', PillSlider);
components.set('SupportSpot', SupportSpot);
components.set('TopBanner', TopBanner);
components.set('CompareTableColumn', CompareTableColumn);
components.set('CompareTablesSpot', CompareTablesSpot);
components.set('compareTableSpotTypes', compareTableSpotTypes);
components.set('ContentSliderSpot', ContentSliderSpot);
components.set('CustomerStorySpot', CustomerStorySpot);
components.set('DualColumnPromoItem', DualColumnPromoItem);
components.set('DualColumnPromoSpot', DualColumnPromoSpot);
components.set('dualColumnPromoTypes', dualColumnPromoTypes);
components.set('EnterpriseBatterySpot', EnterpriseBatterySpot);
components.set('EnterpriseGenericPromoSpot', EnterpriseGenericPromoSpot);
components.set('EnterpriseImageSpot', EnterpriseImageSpot);
components.set('GallerySliderSpot', GallerySliderSpot);
components.set('GenericBentoGrid', GenericBentoGrid);
components.set('IconTableSpot', IconTableSpot);
components.set('IntroSection', IntroSection);
components.set('introSectionTypes', introSectionTypes);
components.set('GenericKSPSpot', GenericKSPSpot);
components.set('GenericKSPCardsSpot', GenericKSPCardsSpot);
components.set('KSPHiddenInfoSpot', KSPHiddenInfoSpot);
components.set('PlaceholderContainerContext', PlaceholderContainerContext);
components.set('ScrollingKSPSpot', ScrollingKSPSpot);
components.set('ZoomKSPSpot', ZoomKSPSpot);
components.set('LogoSpot', LogoSpot);
components.set('MediaTabs', MediaTabs);
components.set('ProductFilterModuleSpot', ProductFilterModuleSpot);
components.set('ProductTopBanner', ProductTopBanner);
components.set('RelatedProducts', RelatedProducts);
components.set('SAPromoSpot', SAPromoSpot);
components.set('ServiceCard', ServiceCard);
components.set('ServicesSpot', ServicesSpot);
components.set('SingleImageSpot', SingleImageSpot);
components.set('Slider', Slider);
components.set('SliderCard', SliderCard);
components.set('SliderSpot', SliderSpot);
components.set('sliderTypes', sliderTypes);
components.set('SoundDemo', SoundDemo);
components.set('soundDemoTypes', soundDemoTypes);
components.set('SoundDemoClipSwitch', SoundDemoClipSwitch);
components.set('SoundDemoClipToggleGroup', SoundDemoClipToggleGroup);
components.set('SoundDemoEnvironmentSelect', SoundDemoEnvironmentSelect);
components.set('SoundDemoPlayer', SoundDemoPlayer);
components.set('StatsSpot', StatsSpot);
components.set('statsSpotTypes', statsSpotTypes);
components.set('Disclaimer', Disclaimer);
components.set('Stat', Stat);
components.set('DesktopTabNavigation', DesktopTabNavigation);
components.set('ImageTabSlider', ImageTabSlider);
components.set('MobileTabNavigation', MobileTabNavigation);
components.set('TabNavigationContentItem', TabNavigationContentItem);
components.set('TabNavigationItem', TabNavigationItem);
components.set('TabNavigationSpot', TabNavigationSpot);
components.set('tabNavigationSpotTypes', tabNavigationSpotTypes);
components.set('TechSpec', TechSpec);
components.set('TopBannerSlider', TopBannerSlider);
components.set('VideoRoiCalculator', VideoRoiCalculator);
components.set('VideoSpot', VideoSpot);
components.set('CoveoUserAnalytics', CoveoUserAnalytics);
components.set('CoveoAnalyticsProvider', CoveoAnalyticsProvider);
components.set('coveoAnalytics.context', coveoAnalyticscontext);
components.set('useCoveoAnalyticsConfig', useCoveoAnalyticsConfig);
components.set('StyleGuide', StyleGuide);
components.set('HeaderCell', HeaderCell);
components.set('IconCell', IconCell);
components.set('RichTextCell', RichTextCell);
components.set('TableCell', TableCell);
components.set('TableRow', TableRow);
components.set('TableSpot', TableSpot);
components.set('tableSpotTypes', tableSpotTypes);

export const componentBuilder = new ComponentBuilder({ components });

export const moduleFactory = componentBuilder.getModuleFactory();
